import { ComponentType, lazy } from 'react'

type PageModule = { default?: ComponentType } & Record<string, unknown>
type NamedPageLoader = () => Promise<PageModule>

export function createLazyPageFromNamed<K extends string>(
  loader: NamedPageLoader,
  exportName: K,
): ComponentType {
  return lazy(() =>
    loader().then((module) => ({
      default: module[exportName] as ComponentType,
    })),
  )
}